export function useEnvironment() {
  const env = import.meta.env;
  const clientPrefix = env.VITE_CLIENT_PREFIX;
  const mode = env.MODE;
  const demoEnvs = ['demo1'];

  function isEnvironment(envList) {
    return envList.includes(clientPrefix);
  }

  function isLocal() {
    return mode === 'desk';
  }

  function isDemo() {
    return isEnvironment(demoEnvs);
  }

  function isEng() {
    return mode === 'dev';
  }

  function isTest() {
    return mode === 'test';
  }

  function isProd() {
    return mode === 'prod';
  }

  return {
    env,
    demoEnvs,
    isEnvironment,
    isLocal,
    isDemo,
    isEng,
    isTest,
    isProd,
  };
}
